import {
  AGREEMENT_LABEL_ARPA,
  AGREEMENT_LABEL_OIF,
  AGREEMENT_LABEL_PSA,
  AGREEMENT_STATUS_COMPLETED,
  AGREEMENT_STATUS_LABEL,
  AGREEMENT_STATUS_NOT_SENT,
  AGREEMENT_STATUS_SENT,
  AGREEMENT_TEMPLATE_ARPA,
  AGREEMENT_TEMPLATE_OIF,
  AGREEMENT_TEMPLATE_PSA,
  AGREEMENT_TEMPLATE_PSA_OIF,
} from "constants/agreementStatus";
import { STAGE_VARIANT, type StageVariant } from "constants/stageVariant";
import { productKeyIncludes } from "helpers/normalizeString";
import type {
  OpportunityAgreementChip,
  OpportunityAgreementStatus,
} from "types";

const DEFAULT_PRIMARY: OpportunityAgreementChip = {
  template_id: AGREEMENT_TEMPLATE_ARPA,
  label: AGREEMENT_LABEL_ARPA,
  status: AGREEMENT_STATUS_NOT_SENT,
};

const DEFAULT_PSA: OpportunityAgreementChip = {
  template_id: AGREEMENT_TEMPLATE_PSA,
  label: AGREEMENT_LABEL_PSA,
  status: AGREEMENT_STATUS_NOT_SENT,
};

const DEFAULT_OIF: OpportunityAgreementChip = {
  template_id: AGREEMENT_TEMPLATE_OIF,
  label: AGREEMENT_LABEL_OIF,
  status: AGREEMENT_STATUS_NOT_SENT,
};

const DEFAULT_PSA_OIF: OpportunityAgreementChip = {
  template_id: AGREEMENT_TEMPLATE_PSA_OIF,
  label: AGREEMENT_LABEL_OIF,
  status: AGREEMENT_STATUS_NOT_SENT,
};

export const isReverseFactoringProduct = (product?: string | null): boolean =>
  productKeyIncludes(product, { trim: true, keyword: "reverse" });

export const defaultAgreementStatus = (
  product?: string | null,
): OpportunityAgreementStatus => {
  if (isReverseFactoringProduct(product)) {
    return {
      primary: { ...DEFAULT_PSA },
      oif: { ...DEFAULT_PSA_OIF },
    };
  }
  return {
    primary: { ...DEFAULT_PRIMARY },
    oif: { ...DEFAULT_OIF },
  };
};

export const agreementChipsForDisplay = (
  agreement?: OpportunityAgreementStatus | null,
): OpportunityAgreementChip[] => {
  const primary = agreement?.primary;
  if (!primary) {
    return [];
  }
  if (agreement?.oif) {
    return [primary, agreement.oif];
  }
  return [primary];
};

export const agreementStatusToVariant = (status?: string): StageVariant => {
  switch (status) {
    case AGREEMENT_STATUS_COMPLETED:
      return STAGE_VARIANT.success;
    case AGREEMENT_STATUS_SENT:
      return STAGE_VARIANT.warning;
    default:
      return STAGE_VARIANT.error;
  }
};

export const agreementStatusLabel = (status?: string): string => {
  if (status === AGREEMENT_STATUS_COMPLETED) {
    return AGREEMENT_STATUS_LABEL[AGREEMENT_STATUS_COMPLETED];
  }
  if (status === AGREEMENT_STATUS_SENT) {
    return AGREEMENT_STATUS_LABEL[AGREEMENT_STATUS_SENT];
  }
  return AGREEMENT_STATUS_LABEL[AGREEMENT_STATUS_NOT_SENT];
};
